import { EntityModel } from '@/interfaces'
import {
  ALL_TENANTS_QUERY,
  CREATE_TENANT_MUTATION,
  DELETE_TENANT_MUTATION,
  FORCE_DELETE_TENANT_MUTATION,
  SINGLE_TENANT_QUERY,
  UPDATE_TENANT_MUTATION,
} from './graphql'
import tenantCmsEntity from '@/entities/tenantCms/entity'
import travelTypeEntity from '@/entities/travelType/entity'
import employeeEntity from '@/entities/employee/entity'
import tenantEmailConfigEntity from '@/entities/tenantEmailConfig/entity'
import newsletterProviderEntity from '@/entities/newsletterProvider/entity'
import redirectEntity from '@/entities/redirect/entity'
import tenantOnlinePaymentConfigEntity from '@/entities/tenantOnlinePaymentConfig/entity'
import tenantRatioConfigEntity from '@/entities/tenantRatioConfig/entity'
import tenantContentEntity from '@/entities/tenantContent/entity'
import partnerTenantEntity from '@/entities/partnerTenant/entity'

const tenantModel: EntityModel = {
  name: 'tenant',
  namePlural: 'tenants',
  uniqueName: 'tenant',
  uniqueNamePlural: 'tenants',
  path: 'config/tenant/tenant',
  baseUrl: '/config/tenants',
  translationPrefix: 'entities:tenant.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_TENANTS_QUERY,
    getSingle: SINGLE_TENANT_QUERY,
    create: CREATE_TENANT_MUTATION,
    update: UPDATE_TENANT_MUTATION,
    delete: DELETE_TENANT_MUTATION,
    forceDelete: FORCE_DELETE_TENANT_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:tenant.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    slug: {
      name: 'slug',
      label: 'entities:tenant.attributes.slug.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[a-z-]*$/,
        },
      ],
    },
    domain: {
      name: 'domain',
      label: 'entities:tenant.attributes.domain.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    externalReference: {
      name: 'externalReference',
      label: 'entities:tenant.attributes.externalReference.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    cms: {
      name: 'cms',
      label: 'entities:tenant.attributes.cms.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantCmsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    travelTypes: {
      name: 'travelTypes',
      label: 'entities:tenant.attributes.travelTypes.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelTypeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    employees: {
      name: 'employees',
      label: 'entities:tenant.attributes.employees.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return employeeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    emailConfig: {
      name: 'emailConfig',
      label: 'entities:tenant.attributes.emailConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEmailConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    newsletterProvider: {
      name: 'newsletterProvider',
      label: 'entities:tenant.attributes.newsletterProvider.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return newsletterProviderEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    redirects: {
      name: 'redirects',
      label: 'entities:tenant.attributes.redirects.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return redirectEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    onlinePaymentConfig: {
      name: 'onlinePaymentConfig',
      label: 'entities:tenant.attributes.onlinePaymentConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantOnlinePaymentConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    ratioConfig: {
      name: 'ratioConfig',
      label: 'entities:tenant.attributes.ratioConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantRatioConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    content: {
      name: 'content',
      label: 'entities:tenant.attributes.content.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantContentEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    partnerTenants: {
      name: 'partnerTenants',
      label: 'entities:tenant.attributes.partnerTenants.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return partnerTenantEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default tenantModel
